import React from "react";
import DataSelect from "@controls/DataEntry/DataSelect/index.js";
const useProductLanguageCode =
  await import("@customHooks/useProductLanguageCode.js").then(
    (mod) => mod.useProductLanguageCode,
  );
const LanguagesData = await import("@data/LanguagesData.js").then(
  (mod) => mod.LanguagesData,
);
const GetDictionaryStorage =
  await import("@asyncImports/GetDictionaryStorage.js").then(
    (mod) => mod.GetDictionaryStorage,
  );
const LanguageEntry = ({
  name,
  state,
  data,
  defaultselected,
  onChange = null,
  required = null,
}) => {
  const CFW_DROPDOWN_LANGUAGE = "DROPDOWN_LANGUAGE";
  const { languageCode } = useProductLanguageCode();
  if (!defaultselected && !required) {
    defaultselected = null;
  } else {
    defaultselected = languageCode;
  }
  return (
    <DataSelect
      name={name ?? "LanguageCode"}
      state={state}
      required={required}
      tran="73"
      onChange={() => {
        if (onChange) {
          onChange();
        }
      }}
      capture={CFW_DROPDOWN_LANGUAGE}
      defaultselected={defaultselected}
      data={
        data ??
        GetDictionaryStorage(LanguagesData, "LanguageCode", "LanguageName")
      }
    />
  );
};
export default LanguageEntry;
